<div class="d-flex gap-3">
  <img src="assets/images/all-img/headerLogo.svg" alt="Logo" width="auto" height="42" priority
    style="cursor: pointer" />
  <img src="assets/images/all-img/headerMinistryOfLabour.svg" alt="Ministry Of Labour" width="auto" height="42" priority
    style="cursor: pointer" />
</div>
<!-- <img src="assets/images/all-img/logo.svg"  alt="logo" width="270" priority style="cursor: pointer" /> -->